'use client';

import {QueryClientProvider} from '@tanstack/react-query';
import React from 'react';
import getQueryClient from './getQueryClient';

interface ReactQueryClientProviderProps {
  children: React.ReactNode;
}
export default function ReactQueryClientProvider(
  props: ReactQueryClientProviderProps
) {
  return (
    <QueryClientProvider client={getQueryClient()}>
      {props.children}
    </QueryClientProvider>
  );
}
